import { Divider, useMediaQuery, useTheme } from '@mui/material';
import { isMobile, isTablet } from 'react-device-detect';

import { AvatarHairColor } from './AvatarHairColor';
import { AvatarSelection } from './AvatarSelection';
import { AvatarShirtColor } from './AvatarShirtColor';
import { AvatarSkinTone } from './AvatarSkinTone';
import './Avatar.css';
import {
  AvatarComponent,
  ChooseAvatarTextForMobiledevice,
} from './AvatarStyled';
import { SkipProfileSelection } from '../ManageProfile/SkipProfileSelection';

interface AvatarProps {
  scope: 'family' | 'subscriber';
}

export const Avatar = ({ scope }: AvatarProps) => {
  const theme = useTheme();
  const ChooseAvatarText = useMediaQuery(theme.breakpoints.down('md'));
  const isSmallScreen = isMobile || isTablet;

  return (
    <AvatarComponent>
      {ChooseAvatarText && (
        <ChooseAvatarTextForMobiledevice variant="body1">
          Or choose your avatar
        </ChooseAvatarTextForMobiledevice>
      )}
      <AvatarSelection scope={scope} />
      <Divider variant="middle" />
      <AvatarSkinTone />
      <Divider variant="middle" />
      <AvatarHairColor />
      <Divider variant="middle" />
      <AvatarShirtColor />
      {isSmallScreen && (
        <>
          <Divider variant="middle" />
          <SkipProfileSelection navigateTo="profile" />
        </>
      )}
    </AvatarComponent>
  );
};
